import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import TopMenu from './top-menu'
import HorMenu from './hor-menu'
import TenantUserSelect from './tenant-user-select'

class Header extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      menuVisibility: false
    }

    this.toggleMenu = this.toggleMenu.bind(this)
    this.hideMenu = this.hideMenu.bind(this)
  }

  toggleMenu () {
    this.setState(currentState => ({
      menuVisibility: !currentState.menuVisibility
    }))
  }

  hideMenu () {
    this.setState({
      menuVisibility: false
    })
  }

  render () {
    const {
      isAuthenticated,
      onLogoutClick,
      username,
      permissions,
      profilePicUrl,
      onTenantUserSelect,
      canCreate
    } = this.props

    return (
      <div className='page-header'>
        <div className='page-header-top'>
          <div className='container'>
            <div className='page-header-container'>
              <div className='page-logo'>
                <Link to='/'>
                  <img src={'/assets/images/logo.png'} alt='Bluerobot Logo' />
                </Link>
              </div>
              {isAuthenticated ? (
                <TopMenu
                  username={username}
                  onLogoutClick={onLogoutClick}
                  permissions={permissions}
                  profilePicUrl={profilePicUrl}
                />
              ) : null}
              <div className='page-menu-toggle' onClick={this.toggleMenu}>
                <i className='fa fa-bars' />
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            'page-header-menu' + (this.state.menuVisibility ? ' open' : '')
          }
        >
          <div className='container'>
            <div className='page-menu-container'>
              {isAuthenticated && canCreate ? (
              [
                <div
                  key={1}
                  className='page-menu-list'
                  onClick={this.hideMenu}
                  >
                  <HorMenu />
                </div>,
                <div key={2} className='tenant-menu'>
                  <TenantUserSelect onTenantUserSelect={onTenantUserSelect} />
                </div>
              ]
              ) : (
                <div className='row'>
                  <div className='col-md-12'>
                    <h3 className='navbar-nav'>
                      Blue Robot: Twitter and Instagram automation for
                      non-techies
                    </h3>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Header.displayName = 'Header'

Header.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  onLogoutClick: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  permissions: PropTypes.array.isRequired,
  profilePicUrl: PropTypes.string.isRequired,
  onTenantUserSelect: PropTypes.func.isRequired,
  canCreate: PropTypes.bool.isRequired
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/index.js